import { render, staticRenderFns } from "./undercarriageGoBackTable.vue?vue&type=template&id=2f73c234&scoped=true"
import script from "./undercarriageGoBackTable.vue?vue&type=script&lang=js"
export * from "./undercarriageGoBackTable.vue?vue&type=script&lang=js"
import style0 from "./undercarriageGoBackTable.vue?vue&type=style&index=0&id=2f73c234&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73c234",
  null
  
)

export default component.exports